module.exports = __webpack_public_path__ + "static/media/je.aa6a92cf.svg";